import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
// Style DevExtreme muszą być globalne - kontrolek DevExtreme używa kilkadziesiąt
// komponentów na wielu stronach (m.in. modal wyboru firmy przy logowaniu i filtry
// na liście kontrahentów). Wcześniej wjeżdżały do wspólnego bundle'a przypadkiem,
// przez import w ShopPageIndex; po podziale na chunki ładowałyby się dopiero
// po wejściu do sklepu, a pozostałe strony renderowałyby kontrolki bez stylów.
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
// Style komponentów współdzielonych przez całą aplikację. Były importowane w
// ShopPageIndex i przed podziałem na chunki trafiały do wspólnego bundle'a, więc
// działały wszędzie. HomePage.css styluje m.in. pasek nawigacji, logo, strzałkę
// "do góry" i checkboxy, a products.css - kafelki produktów (sklep, koszyk,
// szybkokoszyki, oferty, obserwowane). Muszą być globalne, bo te komponenty
// renderują się na wielu stronach.
import "./Pages/HomePage.css";
import "./Components/HomePage/products.css";
// Pozostałe style aplikacji (~86 KB łącznie) ładowane z góry, w kolejności sprzed
// podziału na chunki. Dzielimy JavaScript (tam są megabajty), a nie CSS - patrz
// komentarz w AllAppStyles.js.
import "./Styles/AllAppStyles";
// Globalne nadpisania tabel bootstrapowych i checkboxów DevExtreme - musi być PO
// bootstrapie i dx.light.css, bo je nadpisuje (szczegóły w komentarzu pliku).
import "./Styles/GlobalOverrides.css";
import "/node_modules/flag-icons/css/flag-icons.min.css";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import NewApp from "./NewApp.jsx";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const appVersion = localStorage.getItem("APP_VERSION") || "1.0.0";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ["pl", "en", "de"],

    fallbackLng: "pl",

    detection: {
      order: ["path", "cookie", "htmlTag", "localStorage", "subdomain"],
      caches: ["cookie"],
    },

    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
      queryStringParams: { v: appVersion },
    },
  });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <NewApp />
  </StrictMode>,
);
